import { render, staticRenderFns } from "./SampleDetailMap.vue?vue&type=template&id=2823b222&"
import script from "./SampleDetailMap.vue?vue&type=script&lang=js&"
export * from "./SampleDetailMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports